var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { SAButton } from '../button';
import { SAInput } from '../input';
import { SAIcons } from '../icon';
import { SATag } from '../tag';
// TODO: Figure out why this any type is needed.
var Tags = styled.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return "\n      display: flex;\n      flex-direction: row;\n      flex-wrap: wrap;\n\n      li {\n        height: 35px;\n        margin-right: " + (theme === null || theme === void 0 ? void 0 : theme.size.spacer.small) + ";\n        margin-bottom: " + (theme === null || theme === void 0 ? void 0 : theme.size.spacer.xs) + ";\n\n        &:last-child {\n          margin-right: 0;\n        }\n      }\n    ";
});
export function SASearch(_a) {
    var fullWidth = _a.fullWidth, hint = _a.hint, id = _a.id, label = _a.label, onSearch = _a.onSearch, placeholder = _a.placeholder, values = _a.values, variant = _a.variant;
    var _b = useState(''), search = _b[0], setSearch = _b[1];
    var _c = useState(0), searchCount = _c[0], setSearchCount = _c[1];
    var _d = useState([]), searchTerms = _d[0], setSearchTerms = _d[1];
    function addSearchTerm(searchTerm) {
        // add search term to array if it isn't an empty string and doesn't exist in the array.
        if (searchTerm && searchTerm !== '' && !searchTerms.includes(searchTerm)) {
            setSearchTerms(__spreadArrays(searchTerms, [searchTerm]));
        }
        setSearchCount(searchCount + 1);
    }
    function addSearch(searchString) {
        setSearch(searchString);
        setSearchCount(searchCount + 1);
    }
    function handleClickIcon(e) {
        var parentElement = e.currentTarget.parentElement;
        var input = parentElement.querySelector('input');
        if (variant === 'search-terms') {
            var searchTerm = input.value.trim();
            addSearchTerm(searchTerm);
            // clear input value
            input.value = '';
        }
        else {
            addSearch(input.value.trim());
        }
    }
    function handleKeyDown(e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            var parentElement = e.currentTarget.parentElement;
            var input = parentElement.querySelector('input');
            if (variant === 'search-terms') {
                var searchTerm = input.value.trim();
                addSearchTerm(searchTerm);
                // clear input value
                input.value = '';
            }
            else {
                addSearch(input.value.trim());
            }
        }
    }
    function handleTagClose(_, tagLabel) {
        var indexToRemove = -1;
        searchTerms.map(function (item, index) {
            if (item === tagLabel) {
                indexToRemove = index;
            }
            return true;
        });
        var newArray = __spreadArrays(searchTerms);
        newArray.splice(indexToRemove, 1);
        setSearchTerms(newArray);
        setSearchCount(searchCount + 1);
    }
    function handleClearAll() {
        var newArray = [];
        setSearchTerms(newArray);
        setSearchCount(searchCount + 1);
    }
    useEffect(function () {
        if (onSearch && searchCount) {
            if (variant === 'search-terms') {
                onSearch(searchTerms);
            }
            else {
                onSearch(search);
            }
        }
    }, [searchCount]);
    useEffect(function () {
        setSearchTerms(values);
    }, [values]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Tags, null,
            searchTerms.map(function (item) {
                return (React.createElement(SATag, { key: item, variant: "standard", closeable: true, onClose: handleTagClose, withBorder: true, radius: "small", fontWeight: "normal", label: item }));
            }),
            searchTerms.length > 0 && (React.createElement(SAButton, { label: "Clear All", color: "primary", variant: "link-small", onClick: handleClearAll }))),
        React.createElement(SAInput, { id: id, label: label, hint: hint, type: "search", variant: "search", icon: SAIcons.search, iconSize: "20px", iconColor: "secondary", onClickIcon: handleClickIcon, onKeyDown: handleKeyDown, fullWidth: fullWidth, placeholder: placeholder })));
}
SASearch.defaultProps = {
    fullWidth: false,
    hint: undefined,
    label: undefined,
    onClick: undefined,
    placeholder: undefined,
    values: [],
    variant: 'search',
};
var templateObject_1;
//# sourceMappingURL=search.component.js.map